import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FilterSetComponent } from './filter-set.component'
import { FiltersModule } from '../filters/filters.module'
import { SegmentedControlModule } from '../segmented-control/segmented-control.module'

@NgModule({
  imports: [CommonModule, FiltersModule, SegmentedControlModule],
  declarations: [FilterSetComponent],
  exports: [FilterSetComponent]
})
export class FilterSetModule {}
